import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { PaymentsPage } from "./pages/Payments";
import { RecipientsPage } from "./pages/Recipients";
import { VerificationPage } from "./pages/Verification";

/** Money-movement routes (accounts, payments, recipients, onboarding) under /o/$orgId. */
export function extraOrgRoutes(parent: AnyRoute): AnyRoute[] {
  return [
    createRoute({ getParentRoute: () => parent, path: "/verification", component: VerificationPage }),
    createRoute({ getParentRoute: () => parent, path: "/payments", component: PaymentsPage }),
    createRoute({ getParentRoute: () => parent, path: "/recipients", component: RecipientsPage }),
  ];
}
